import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '@env/environment';
import {Page} from '@app/domain/page';
import {PedidoTiendaOnline, EstadoPedidoTiendaOnline} from '@app/domain/pedido-tienda-online';
import {Ticket} from '@app/domain/ventas/ticket';

@Injectable({
    providedIn: 'root'
})
export class PedidoTiendaOnlineService {

    private baseUrl: string = environment.endpointApi;

    constructor(private http: HttpClient) {
    }

    savePublic(model: PedidoTiendaOnline): Observable<PedidoTiendaOnline> {
        return this.http.post<PedidoTiendaOnline>(`${this.baseUrl}/public/pedidos-tienda-online`, model);
    }

    findAllPage(params: string): Observable<Page<PedidoTiendaOnline>> {
        return this.http.get<Page<PedidoTiendaOnline>>(`${this.baseUrl}/pedidos-tienda-online?${params}`);
    }

    findById(id: number): Observable<PedidoTiendaOnline> {
        return this.http.get<PedidoTiendaOnline>(`${this.baseUrl}/pedidos-tienda-online/${id}`);
    }

    buildVentaDraft(id: number): Observable<Ticket> {
        return this.http.get<Ticket>(`${this.baseUrl}/pedidos-tienda-online/${id}/venta-draft`);
    }

    cambiarEstado(id: number, estado: EstadoPedidoTiendaOnline): Observable<PedidoTiendaOnline> {
        return this.http.patch<PedidoTiendaOnline>(`${this.baseUrl}/pedidos-tienda-online/${id}/estado?estado=${estado}`, {});
    }
}
